export default "__VITE_ASSET__u1LFabEQ__"